
import Paper from "@mui/material/Paper";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { grey, red } from '@mui/material/colors';

// 商品追加マスタ取得表
export default function ProductMasterTable({dataList, selectProductData}) {
    const onClickSelect = (data) => (event) => {
      selectProductData(data)
    }
  
    var lastName = ""
    var lastOrigin = ""
  
    if (dataList.length > 0) {
      return (
        <TableContainer component={Paper} sx={{maxHeight:200}} >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>商品名</TableCell>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>産地</TableCell>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>規格</TableCell>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>発注単位</TableCell>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>選択</TableCell>
                <TableCell sx={{backgroundColor: grey[100], padding: 1}}>追加済</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataList.map((data, i) => {
                var displayName = (lastName === data.productName) ? "" : data.productName;
                var displayOrigin = (lastName === data.productName && lastOrigin === data.origin) ? "" : data.origin;
    
                lastName = data.productName;
                lastOrigin = data.origin;
    
                return (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row" sx={{fontWeight: "bold", padding: 1, width: "20%"}}>{displayName}</TableCell>
                    <TableCell sx={{padding: 1, width: "15%"}}>{displayOrigin}</TableCell>
                    <TableCell sx={{padding: 1, width: "30%"}}>{data.displaySize}</TableCell>
                    <TableCell sx={{padding: 1}}>{data.orderingUnit}</TableCell>
                    <TableCell sx={{padding: 1}}>
                      <Button variant="outlined" disabled={data.added} onClick={onClickSelect(data)}>選択</Button>
                    </TableCell>
                    <TableCell sx={{padding: 1, color: red[500]}}>{data.added ? "追加済" : ""}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )
    }
  
    return <Typography>該当する商品がマスタに存在しません</Typography>;  
  }